
import { defineComponent } from "vue";
import {
	AspectSection,
	CharacterInfoSection,
	DescriptionSection,
	InventorySection,
	MetaInfoSection,
	SheetHeader,
	SkillsSection,
	StuntsSection,
} from "@/widgets";

export default defineComponent({
	name: "CharacterSheet",
	components: {
		SheetHeader,
		CharacterInfoSection,
		MetaInfoSection,
		DescriptionSection,
		InventorySection,
		StuntsSection,
		SkillsSection,
		AspectSection,
	},
	emits: ["char-updated"],
});
